export const blocks = () => {
    const $ = jQuery;

    const blocks_triggers = $('.blocks-trigger');
    
    const handleBlocksTriggers = (e) => {
        e.preventDefault();

        const trigger = $(e.currentTarget);

        trigger.parents('.cta-full-width').siblings('.blocks').slideToggle();
    }

    blocks_triggers.on('click', handleBlocksTriggers);
};